import { GET_LINKEDIN_POSTS } from "services/url.service";
import { commonTransform } from "../handleTransformation";

export const linkedInQueries = {
  getLinkedInPosts: {
    getUrl: ({companyId}) =>  GET_LINKEDIN_POSTS(companyId),
    transformResponse: (res) => commonTransform(res),
    method: "GET",
  },
};
